import React, { forwardRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ja from "date-fns/locale/ja";
registerLocale("ja", ja);

// search_form_calendar.jsx（画面上の日付タブ）と、検索フォームの「別条件で検索する」モーダルの
// 両方から使う「別日を選択」ボタン。react-datepickerの設定・onChangeロジックを1箇所にまとめて共有する。
const DatePickerButton = forwardRef(({ onClick }, ref) => (
  <button
    type="button"
    className="search-event__date-picker-btn-2026"
    onClick={onClick}
    ref={ref}
  >
    <i className="far fa-calendar-alt" aria-hidden="true"></i>
    別日を選択
  </button>
));
DatePickerButton.displayName = "Calendar";

const handleCalendarOpen = () => {
  document.addEventListener(
    "touchstart",
    (e) => {
      e.stopPropagation();
    },
    true
  );
};

// withPortal: search_form_calendar.jsx（日付タブ横の従来配置。ジャンル別ページ等）では
// これまで通りフルスクリーンのポータル表示のままにする。検索フォームの「別条件で検索する」
// モーダルの中から開く場合は、モーダル自身がフルスクリーンオーバーレイのため、カレンダーの
// ポータルと二重に重なって表示位置がずれ、見えなくなる。そのためモーダル内からは
// withPortal={false}を渡し、ボタン直下にアンカー表示する。
const SearchFormDatePickerButton = ({ eventDate, eventDateFunc, withPortal = true }) => (
  <DatePicker
    locale="ja"
    selected={eventDate && moment(eventDate).toDate()}
    minDate={new Date()}
    withPortal={withPortal}
    popperPlacement={withPortal ? undefined : "bottom"}
    onChange={(date) => eventDateFunc(moment(date).format("YYYY-MM-DD"))}
    customInput={<DatePickerButton />}
    onCalendarOpen={handleCalendarOpen}
  />
);

export default SearchFormDatePickerButton;
